export const industryFacetsData = 
{
    "A,00,000,0000": {
        "name": "農業，林業",
        "hitcount": undefined,
        "childDataDict": {
            "A,01,000,0000": {
                "name": "農業",
                "hitcount": undefined,
                "childDataDict": {
                    "A,01,010,0000": {
                        "name": "管理，補助的経済活動を行う事業所（01農業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,01,011,0000": {
                        "name": "耕種農業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,01,012,0000": {
                        "name": "畜産農業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,01,013,0000": {
                        "name": "農業サービス業（園芸サービス業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,01,014,0000": {
                        "name": "園芸サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "A,02,000,0000": {
                "name": "林業",
                "hitcount": undefined,
                "childDataDict": {
                    "A,02,020,0000": {
                        "name": "管理，補助的経済活動を行う事業所（02林業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,02,021,0000": {
                        "name": "育林業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,02,022,0000": {
                        "name": "素材生産業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,02,023,0000": {
                        "name": "特用林産物生産業（きのこ類の栽培を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,02,024,0000": {
                        "name": "林業サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "A,02,029,0000": {
                        "name": "その他の林業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "B,00,000,0000": {
        "name": "漁業",
        "hitcount": undefined,
        "childDataDict": {
            "B,03,000,0000": {
                "name": "漁業（水産養殖業を除く）",
                "hitcount": undefined,
                "childDataDict": {
                    "B,03,030,0000": {
                        "name": "管理，補助的経済活動を行う事業所（03漁業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "B,03,031,0000": {
                        "name": "海面漁業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "B,03,032,0000": {
                        "name": "内水面漁業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "B,04,000,0000": {
                "name": "水産養殖業",
                "hitcount": undefined,
                "childDataDict": {
                    "B,04,040,0000": {
                        "name": "管理，補助的経済活動を行う事業所（04水産養殖業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "B,04,041,0000": {
                        "name": "海面養殖業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "B,04,042,0000": {
                        "name": "内水面養殖業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "C,00,000,0000": {
        "name": "鉱業，採石業，砂利採取業",
        "hitcount": undefined,
        "childDataDict": {
            "C,05,000,0000": {
                "name": "鉱業，採石業，砂利採取業",
                "hitcount": undefined,
                "childDataDict": {
                    "C,05,050,0000": {
                        "name": "管理，補助的経済活動を行う事業所（05鉱業，採石業，砂利採取業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "C,05,051,0000": {
                        "name": "その他の金属鉱業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "C,05,052,0000": {
                        "name": "石炭・亜炭鉱業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "C,05,053,0000": {
                        "name": "原油・天然ガス鉱業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "C,05,054,0000": {
                        "name": "石英粗面岩・同類似岩石採石業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "C,05,055,0000": {
                        "name": "窯業原料用鉱物鉱業（耐火物・陶磁器・ガラス・セメント原料用に限る）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "C,05,059,0000": {
                        "name": "滑石鉱業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "E,00,000,0000": {
        "name": "製造業",
        "hitcount": undefined,
        "childDataDict": {
            "E,09,000,0000": {
                "name": "食料品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,09,090,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,091,0000": {
                        "name": "畜産食料品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,092,0000": {
                        "name": "水産練製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,093,0000": {
                        "name": "野菜漬物製造業（缶詰，瓶詰，つぼ詰を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,094,0000": {
                        "name": "食酢製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,095,0000": {
                        "name": "砂糖製造業（砂糖精製業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,096,0000": {
                        "name": "その他の精穀・製粉業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,097,0000": {
                        "name": "ビスケット類・干菓子製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,098,0000": {
                        "name": "動植物油脂製造業（食用油脂加工業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,09,099,0000": {
                        "name": "豆腐・油揚製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,10,000,0000": {
                "name": "飲料・たばこ・飼料製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,10,100,0000": {
                        "name": "管理，補助的経済活動を行う事業所（10飲料・たばこ・飼料製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,10,101,0000": {
                        "name": "清涼飲料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,10,102,0000": {
                        "name": "酒類製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,10,103,0000": {
                        "name": "コーヒー製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,10,104,0000": {
                        "name": "製氷業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,10,105,0000": {
                        "name": "たばこ製造業（葉たばこ処理業を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,10,106,0000": {
                        "name": "有機質肥料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,11,000,0000": {
                "name": "繊維工業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,11,110,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,111,0000": {
                        "name": "綿紡績業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,112,0000": {
                        "name": "麻織物業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,113,0000": {
                        "name": "横編ニット生地製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,114,0000": {
                        "name": "織物整理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,115,0000": {
                        "name": "レース製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,116,0000": {
                        "name": "その他の外衣・シャツ製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,117,0000": {
                        "name": "ニット製下着製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,118,0000": {
                        "name": "靴下製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,11,119,0000": {
                        "name": "他に分類されない繊維製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,12,000,0000": {
                "name": "木材・木製品製造業（家具を除く）",
                "hitcount": undefined,
                "childDataDict": {
                    "E,12,120,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,12,121,0000": {
                        "name": "木材チップ製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,12,122,0000": {
                        "name": "合板製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,12,123,0000": {
                        "name": "木箱製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,12,129,0000": {
                        "name": "木材薬品処理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,13,000,0000": {
                "name": "家具・装備品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,13,130,0000": {
                        "name": "管理，補助的経済活動を行う事業所（13家具・装備品製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,13,131,0000": {
                        "name": "木製家具製造業（漆塗りを除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,13,132,0000": {
                        "name": "宗教用具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,13,133,0000": {
                        "name": "建具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,13,139,0000": {
                        "name": "事務所用・店舗用装備品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,14,000,0000": {
                "name": "パルプ・紙・紙加工品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,14,140,0000": {
                        "name": "管理，補助的経済活動を行う事業所（14パルプ・紙・紙加工品製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,14,141,0000": {
                        "name": "パルプ製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,14,142,0000": {
                        "name": "洋紙製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,14,143,0000": {
                        "name": "塗工紙製造業（印刷用紙を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,14,144,0000": {
                        "name": "紙製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,14,145,0000": {
                        "name": "紙器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,14,149,0000": {
                        "name": "その他のパルプ・紙・紙加工品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,15,000,0000": {
                "name": "印刷・同関連業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,15,150,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,15,151,0000": {
                        "name": "オフセット印刷以外の印刷業（紙に対するもの）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,15,152,0000": {
                        "name": "製版業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,15,153,0000": {
                        "name": "製本業，印刷物加工業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,15,159,0000": {
                        "name": "印刷関連サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,16,000,0000": {
                "name": "化学工業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,16,160,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,161,0000": {
                        "name": "複合肥料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,162,0000": {
                        "name": "塩製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,163,0000": {
                        "name": "合成ゴム製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,164,0000": {
                        "name": "塗料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,165,0000": {
                        "name": "医薬品製剤製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,166,0000": {
                        "name": "化粧品・歯磨・その他の化粧用調整品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,16,169,0000": {
                        "name": "香料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,17,000,0000": {
                "name": "石油製品・石炭製品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,17,170,0000": {
                        "name": "管理，補助的経済活動を行う事業所（17石油製品・石炭製品製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,17,171,0000": {
                        "name": "石油精製業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,17,172,0000": {
                        "name": "潤滑油・グリース製造業（石油精製業によらないもの）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,17,173,0000": {
                        "name": "コークス製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,17,174,0000": {
                        "name": "舗装材料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,17,179,0000": {
                        "name": "その他の石油製品・石炭製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,18,000,0000": {
                "name": "プラスチック製品製造業（別掲を除く）",
                "hitcount": undefined,
                "childDataDict": {
                    "E,18,180,0000": {
                        "name": "管理，補助的経済活動を行う事業所（18プラスチック製品製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,18,181,0000": {
                        "name": "プラスチック板・棒・管・継手・異形押出製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,18,182,0000": {
                        "name": "プラスチックフィルム・シート・床材・合成皮革製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,18,183,0000": {
                        "name": "その他の工業用プラスチック製品製造業（加工業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,18,184,0000": {
                        "name": "発泡・強化プラスチック製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,18,185,0000": {
                        "name": "プラスチック成形材料製造業（廃プラスチックを含む）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,18,189,0000": {
                        "name": "他に分類されないプラスチック製品加工業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,19,000,0000": {
                "name": "ゴム製品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,19,190,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,19,191,0000": {
                        "name": "タイヤ・チューブ製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,19,192,0000": {
                        "name": "ゴム製・プラスチック製履物・同附属品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,19,193,0000": {
                        "name": "ゴムベルト・ゴムホース・工業用ゴム製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,19,199,0000": {
                        "name": "医療・衛生用ゴム製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,20,000,0000": {
                "name": "なめし革・同製品・毛皮製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,20,200,0000": {
                        "name": "管理，補助的経済活動を行う事業所（20なめし革・同製品・毛皮製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,201,0000": {
                        "name": "なめし革製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,202,0000": {
                        "name": "工業用革製品製造業（手袋を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,203,0000": {
                        "name": "革製履物用材料・同附属品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,204,0000": {
                        "name": "革製履物製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,205,0000": {
                        "name": "革製手袋製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,206,0000": {
                        "name": "かばん製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,207,0000": {
                        "name": "袋物製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,208,0000": {
                        "name": "毛皮製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,20,209,0000": {
                        "name": "その他のなめし革製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,21,000,0000": {
                "name": "窯業・土石製品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,21,210,0000": {
                        "name": "管理，補助的経済活動を行う事業所（21窯業・土石製品製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,211,0000": {
                        "name": "ガラス・同製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,212,0000": {
                        "name": "セメント・同製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,213,0000": {
                        "name": "建設用粘土製品製造業（陶磁器製を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,214,0000": {
                        "name": "陶磁器絵付業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,215,0000": {
                        "name": "その他の耐火物製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,216,0000": {
                        "name": "炭素・黒鉛製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,217,0000": {
                        "name": "研磨布紙製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,218,0000": {
                        "name": "再生骨材製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,21,219,0000": {
                        "name": "ロックウール・同製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,22,000,0000": {
                "name": "鉄鋼業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,22,220,0000": {
                        "name": "管理，補助的経済活動を行う事業所（22鉄鋼業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,22,221,0000": {
                        "name": "高炉によらない製鉄業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,22,222,0000": {
                        "name": "製鋼・製鋼圧延業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,22,223,0000": {
                        "name": "冷間圧延業（鋼管，伸鉄を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,22,224,0000": {
                        "name": "表面処理鋼材製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,22,225,0000": {
                        "name": "鉄素形材製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,22,229,0000": {
                        "name": "その他の鉄鋼業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,23,000,0000": {
                "name": "非鉄金属製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,23,230,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,23,231,0000": {
                        "name": "亜鉛第1次製錬・精製業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,23,232,0000": {
                        "name": "アルミニウム第2次製錬・精製業（アルミニウム合金製造業を含む）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,23,233,0000": {
                        "name": "アルミニウム・同合金圧延業（抽伸，押出しを含む）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,23,234,0000": {
                        "name": "電線・ケーブル製造業（光ファイバケーブルを除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,23,235,0000": {
                        "name": "非鉄金属ダイカスト製造業（アルミニウム・同合金ダイカストを除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,23,239,0000": {
                        "name": "核燃料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,24,000,0000": {
                "name": "金属製品製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,24,240,0000": {
                        "name": "管理，補助的経済活動を行う事業所（24金属製品製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,241,0000": {
                        "name": "ブリキ缶・その他のめっき板等製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,242,0000": {
                        "name": "手引のこぎり・のこ刃製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,243,0000": {
                        "name": "温風・温水暖房装置製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,244,0000": {
                        "name": "建設用・建築用金属製品製造業（製缶板金業を含む)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,245,0000": {
                        "name": "金属素形材製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,246,0000": {
                        "name": "金属製品塗装業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,247,0000": {
                        "name": "金属線製品製造業（ねじ類を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,248,0000": {
                        "name": "ボルト・ナット・リベット・小ねじ・木ねじ等製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,24,249,0000": {
                        "name": "他に分類されない金属製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,25,000,0000": {
                "name": "はん用機械器具製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,25,250,0000": {
                        "name": "管理，補助的経済活動を行う事業所（25はん用機械器具製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,25,251,0000": {
                        "name": "はん用内燃機関製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,25,252,0000": {
                        "name": "ポンプ・圧縮機器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,25,253,0000": {
                        "name": "エレベータ・エスカレータ製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,25,259,0000": {
                        "name": "その他のはん用機械・同部分品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,26,000,0000": {
                "name": "生産用機械器具製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,26,260,0000": {
                        "name": "管理，補助的経済活動を行う事業所（26生産用機械器具製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,261,0000": {
                        "name": "農業用機械製造業（農業用器具を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,262,0000": {
                        "name": "建設機械・鉱山機械製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,263,0000": {
                        "name": "化学繊維機械・紡績機械製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,264,0000": {
                        "name": "パルプ装置・製紙機械製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,265,0000": {
                        "name": "化学機械・同装置製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,266,0000": {
                        "name": "金属工作機械製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,267,0000": {
                        "name": "半導体製造装置製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,26,269,0000": {
                        "name": "非金属用金型・同部分品・附属品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,27,000,0000": {
                "name": "業務用機械器具製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,27,270,0000": {
                        "name": "管理，補助的経済活動を行う事業所（27業務用機械器具製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,27,271,0000": {
                        "name": "その他の事務用機械器具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,27,272,0000": {
                        "name": "自動販売機製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,27,273,0000": {
                        "name": "精密測定器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,27,274,0000": {
                        "name": "歯科材料製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,27,275,0000": {
                        "name": "写真機・映画用機械・同附属品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,27,276,0000": {
                        "name": "武器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,28,000,0000": {
                "name": "電子部品・デバイス・電子回路製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,28,280,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,28,281,0000": {
                        "name": "光電変換素子製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,28,282,0000": {
                        "name": "コネクタ・スイッチ・リレー製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,28,283,0000": {
                        "name": "光ディスク・磁気ディスク・磁気テープ製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,28,284,0000": {
                        "name": "電子回路基板製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,28,285,0000": {
                        "name": "その他のユニット部品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,28,289,0000": {
                        "name": "その他の電子部品・デバイス・電子回路製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,29,000,0000": {
                "name": "電気機械器具製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,29,290,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,291,0000": {
                        "name": "配電盤・電力制御装置製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,292,0000": {
                        "name": "内燃機関電装品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,293,0000": {
                        "name": "その他の民生用電気機械器具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,294,0000": {
                        "name": "電球製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,295,0000": {
                        "name": "蓄電池製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,296,0000": {
                        "name": "その他の電子応用装置製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,297,0000": {
                        "name": "医療用計測器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,29,299,0000": {
                        "name": "その他の電気機械器具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,30,000,0000": {
                "name": "情報通信機械器具製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,30,300,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,30,301,0000": {
                        "name": "有線通信機械器具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,30,302,0000": {
                        "name": "ビデオ機器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,30,303,0000": {
                        "name": "表示装置製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,31,000,0000": {
                "name": "輸送用機械器具製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,31,310,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,31,311,0000": {
                        "name": "自動車部分品・附属品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,31,312,0000": {
                        "name": "鉄道車両用部分品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,31,313,0000": {
                        "name": "船舶製造・修理業，舶用機関製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,31,314,0000": {
                        "name": "航空機用原動機製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,31,315,0000": {
                        "name": "産業用運搬車両・同部分品・附属品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,31,319,0000": {
                        "name": "その他の輸送用機械器具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "E,32,000,0000": {
                "name": "その他の製造業",
                "hitcount": undefined,
                "childDataDict": {
                    "E,32,320,0000": {
                        "name": "管理，補助的経済活動を行う事業所（32その他の製造業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,321,0000": {
                        "name": "貴金属・宝石製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,322,0000": {
                        "name": "装身具・装飾品・ボタン・同関連品製造業（貴金属・宝石製を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,323,0000": {
                        "name": "時計・同部分品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,324,0000": {
                        "name": "楽器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,325,0000": {
                        "name": "がん具・運動用具製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,326,0000": {
                        "name": "ペン・鉛筆・絵画用品・その他の事務用品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,327,0000": {
                        "name": "漆器製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,328,0000": {
                        "name": "畳等生活雑貨製品製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "E,32,329,0000": {
                        "name": "他に分類されない製造業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "F,00,000,0000": {
        "name": "電気・ガス・熱供給・水道業",
        "hitcount": undefined,
        "childDataDict": {
            "F,33,000,0000": {
                "name": "電気業",
                "hitcount": undefined,
                "childDataDict": {
                    "F,33,330,0000": {
                        "name": "管理，補助的経済活動を行う事業所（33電気業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "F,33,331,0000": {
                        "name": "電気業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "F,34,000,0000": {
                "name": "ガス業",
                "hitcount": undefined,
                "childDataDict": {
                    "F,34,340,0000": {
                        "name": "管理，補助的経済活動を行う事業所（34ガス業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "F,34,341,0000": {
                        "name": "ガス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "F,35,000,0000": {
                "name": "熱供給業",
                "hitcount": undefined,
                "childDataDict": {
                    "F,35,350,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "F,35,351,0000": {
                        "name": "熱供給業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "F,36,000,0000": {
                "name": "水道業",
                "hitcount": undefined,
                "childDataDict": {
                    "F,36,360,0000": {
                        "name": "管理，補助的経済活動を行う事業所（36水道業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "F,36,361,0000": {
                        "name": "上水道業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "F,36,362,0000": {
                        "name": "工業用水道業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "F,36,363,0000": {
                        "name": "下水道管路施設維持管理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "H,00,000,0000": {
        "name": "運輸業，郵便業",
        "hitcount": undefined,
        "childDataDict": {
            "H,42,000,0000": {
                "name": "鉄道業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,42,420,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,42,421,0000": {
                        "name": "普通鉄道業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,43,000,0000": {
                "name": "道路旅客運送業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,43,430,0000": {
                        "name": "管理，補助的経済活動を行う事業所（43道路旅客運送業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,43,431,0000": {
                        "name": "一般乗合旅客自動車運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,43,432,0000": {
                        "name": "一般乗用旅客自動車運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,43,433,0000": {
                        "name": "一般貸切旅客自動車運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,43,439,0000": {
                        "name": "その他の道路旅客運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,44,000,0000": {
                "name": "道路貨物運送業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,44,440,0000": {
                        "name": "管理，補助的経済活動を行う事業所（44道路貨物運送業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,44,441,0000": {
                        "name": "一般貨物自動車運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,44,442,0000": {
                        "name": "特定貨物自動車運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,44,443,0000": {
                        "name": "貨物軽自動車運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,44,444,0000": {
                        "name": "集配利用運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,44,449,0000": {
                        "name": "その他の道路貨物運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,45,000,0000": {
                "name": "水運業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,45,450,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,45,451,0000": {
                        "name": "外航旅客海運業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,45,452,0000": {
                        "name": "沿海貨物海運業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,45,453,0000": {
                        "name": "河川水運業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,45,454,0000": {
                        "name": "船舶貸渡業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,46,000,0000": {
                "name": "航空運輸業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,46,460,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,46,461,0000": {
                        "name": "航空運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,46,462,0000": {
                        "name": "航空機使用業（航空運送業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,47,000,0000": {
                "name": "倉庫業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,47,470,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,47,471,0000": {
                        "name": "倉庫業（冷蔵倉庫業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,47,472,0000": {
                        "name": "冷蔵倉庫業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,48,000,0000": {
                "name": "運輸に附帯するサービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "H,48,480,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,48,481,0000": {
                        "name": "港湾運送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,48,482,0000": {
                        "name": "利用運送業（集配利用運送業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,48,483,0000": {
                        "name": "運送代理店",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,48,484,0000": {
                        "name": "こん包業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,48,485,0000": {
                        "name": "道路運送固定施設業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,48,489,0000": {
                        "name": "海運仲立業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "H,49,000,0000": {
                "name": "郵便業（信書便事業を含む）",
                "hitcount": undefined,
                "childDataDict": {
                    "H,49,490,0000": {
                        "name": "管理，補助的経済活動を行う事業所（49郵便業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "H,49,491,0000": {
                        "name": "郵便業（信書便事業を含む）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "I,00,000,0000": {
        "name": "卸売業，小売業",
        "hitcount": undefined,
        "childDataDict": {
            "I,50,000,0000": {
                "name": "各種商品卸売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,50,500,0000": {
                        "name": "自家用倉庫",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,50,501,0000": {
                        "name": "その他の各種商品卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,51,000,0000": {
                "name": "繊維・衣服等卸売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,51,510,0000": {
                        "name": "自家用倉庫",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,51,511,0000": {
                        "name": "織物卸売業（室内装飾繊維品を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,51,512,0000": {
                        "name": "男子服卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,51,513,0000": {
                        "name": "身の回り品卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,52,000,0000": {
                "name": "飲食料品卸売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,52,520,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,52,521,0000": {
                        "name": "農畜産物・水産物卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,52,522,0000": {
                        "name": "食料・飲料卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,53,000,0000": {
                "name": "建築材料，鉱物・金属材料等卸売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,53,530,0000": {
                        "name": "自家用倉庫",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,53,531,0000": {
                        "name": "板ガラス卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,53,532,0000": {
                        "name": "化学製品卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,53,533,0000": {
                        "name": "石油・鉱物卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,53,534,0000": {
                        "name": "鉄鋼製品卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,53,535,0000": {
                        "name": "非鉄金属地金卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,53,536,0000": {
                        "name": "空瓶・空缶等空容器卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,54,000,0000": {
                "name": "機械器具卸売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,54,540,0000": {
                        "name": "管理，補助的経済活動を行う事業所（54機械器具卸売業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,54,541,0000": {
                        "name": "産業機械器具卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,54,542,0000": {
                        "name": "自動車卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,54,543,0000": {
                        "name": "電気機械器具卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,54,549,0000": {
                        "name": "計量器・理化学機械器具・光学機械器具等卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,55,000,0000": {
                "name": "その他の卸売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,55,550,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,55,551,0000": {
                        "name": "畳卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,55,552,0000": {
                        "name": "医療用品卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,55,553,0000": {
                        "name": "紙製品卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,55,559,0000": {
                        "name": "娯楽用品・がん具卸売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,56,000,0000": {
                "name": "各種商品小売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,56,560,0000": {
                        "name": "管理，補助的経済活動を行う事業所（56各種商品小売業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,56,561,0000": {
                        "name": "百貨店，総合スーパー",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,56,569,0000": {
                        "name": "その他の各種商品小売業（従業者が常時50人未満のもの）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,57,000,0000": {
                "name": "織物・衣服・身の回り品小売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,57,570,0000": {
                        "name": "管理，補助的経済活動を行う事業所（57織物・衣服・身の回り品小売業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,57,571,0000": {
                        "name": "呉服・服地・寝具小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,57,572,0000": {
                        "name": "男子服小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,57,573,0000": {
                        "name": "婦人服小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,57,574,0000": {
                        "name": "靴・履物小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,57,579,0000": {
                        "name": "かばん・袋物小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,58,000,0000": {
                "name": "飲食料品小売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,58,580,0000": {
                        "name": "自家用倉庫",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,581,0000": {
                        "name": "各種食料品小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,582,0000": {
                        "name": "果実小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,583,0000": {
                        "name": "食肉小売業（卵，鳥肉を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,584,0000": {
                        "name": "鮮魚小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,585,0000": {
                        "name": "酒小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,586,0000": {
                        "name": "菓子・パン小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,58,589,0000": {
                        "name": "乾物小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,59,000,0000": {
                "name": "機械器具小売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,59,590,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,59,591,0000": {
                        "name": "自動車部分品・附属品小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,59,592,0000": {
                        "name": "自転車小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,59,593,0000": {
                        "name": "電気機械器具小売業（中古品を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,60,000,0000": {
                "name": "その他の小売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,60,600,0000": {
                        "name": "管理，補助的経済活動を行う事業所（60その他の小売業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,601,0000": {
                        "name": "家具・建具・畳小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,602,0000": {
                        "name": "金物小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,603,0000": {
                        "name": "調剤薬局",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,604,0000": {
                        "name": "農業用機械器具小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,605,0000": {
                        "name": "燃料小売業（ガソリンスタンドを除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,606,0000": {
                        "name": "書籍・文房具小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,607,0000": {
                        "name": "スポーツ用品・がん具・娯楽用品・楽器小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,608,0000": {
                        "name": "写真機・時計・眼鏡小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,60,609,0000": {
                        "name": "他に分類されない小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "I,61,000,0000": {
                "name": "無店舗小売業",
                "hitcount": undefined,
                "childDataDict": {
                    "I,61,610,0000": {
                        "name": "管理，補助的経済活動を行う事業所（61無店舗小売業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,61,611,0000": {
                        "name": "通信販売・訪問販売小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,61,612,0000": {
                        "name": "自動販売機による小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "I,61,619,0000": {
                        "name": "その他の無店舗小売業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "J,00,000,0000": {
        "name": "金融業，保険業",
        "hitcount": undefined,
        "childDataDict": {
            "J,62,000,0000": {
                "name": "銀行業",
                "hitcount": undefined,
                "childDataDict": {
                    "J,62,620,0000": {
                        "name": "管理，補助的経済活動を行う事業所（62銀行業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,62,621,0000": {
                        "name": "中央銀行",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,62,622,0000": {
                        "name": "銀行（中央銀行を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "J,63,000,0000": {
                "name": "協同組織金融業",
                "hitcount": undefined,
                "childDataDict": {
                    "J,63,630,0000": {
                        "name": "管理，補助的経済活動を行う事業所（63協同組織金融業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,63,631,0000": {
                        "name": "中小企業等金融業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,63,632,0000": {
                        "name": "農林水産金融業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "J,64,000,0000": {
                "name": "貸金業，クレジットカード業等非預金信用機関",
                "hitcount": undefined,
                "childDataDict": {
                    "J,64,640,0000": {
                        "name": "管理，補助的経済活動を行う事業所（64貸金業，クレジットカード業等非預金信用機関）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,64,641,0000": {
                        "name": "貸金業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,64,642,0000": {
                        "name": "質屋",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,64,643,0000": {
                        "name": "クレジットカード業，割賦金融業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,64,649,0000": {
                        "name": "その他の非預金信用機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "J,65,000,0000": {
                "name": "金融商品取引業，商品先物取引業",
                "hitcount": undefined,
                "childDataDict": {
                    "J,65,650,0000": {
                        "name": "管理，補助的経済活動を行う事業所（65金融商品取引業，商品先物取引業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,65,651,0000": {
                        "name": "金融商品取引業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,65,652,0000": {
                        "name": "商品先物取引業，商品投資顧問業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "J,66,000,0000": {
                "name": "補助的金融業等",
                "hitcount": undefined,
                "childDataDict": {
                    "J,66,660,0000": {
                        "name": "管理，補助的経済活動を行う事業所（66補助的金融業等）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,66,661,0000": {
                        "name": "補助的金融業，金融附帯業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,66,662,0000": {
                        "name": "信託業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,66,663,0000": {
                        "name": "金融代理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "J,67,000,0000": {
                "name": "保険業（保険媒介代理業，保険サービス業を含む）",
                "hitcount": undefined,
                "childDataDict": {
                    "J,67,670,0000": {
                        "name": "管理，補助的経済活動を行う事業所（67保険業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,67,671,0000": {
                        "name": "生命保険業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,67,672,0000": {
                        "name": "損害保険再保険業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,67,673,0000": {
                        "name": "少額短期保険業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,67,674,0000": {
                        "name": "損害保険代理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "J,67,675,0000": {
                        "name": "損害査定業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "K,00,000,0000": {
        "name": "不動産業，物品賃貸業",
        "hitcount": undefined,
        "childDataDict": {
            "K,68,000,0000": {
                "name": "不動産取引業",
                "hitcount": undefined,
                "childDataDict": {
                    "K,68,680,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,68,681,0000": {
                        "name": "建物売買業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,68,682,0000": {
                        "name": "不動産代理業・仲介業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "K,69,000,0000": {
                "name": "不動産賃貸業・管理業",
                "hitcount": undefined,
                "childDataDict": {
                    "K,69,690,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,69,691,0000": {
                        "name": "土地賃貸業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,69,692,0000": {
                        "name": "貸家業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,69,693,0000": {
                        "name": "駐車場業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,69,694,0000": {
                        "name": "不動産管理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "K,70,000,0000": {
                "name": "物品賃貸業",
                "hitcount": undefined,
                "childDataDict": {
                    "K,70,700,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,70,701,0000": {
                        "name": "各種物品賃貸業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,70,702,0000": {
                        "name": "建設機械器具賃貸業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,70,703,0000": {
                        "name": "事務用機械器具賃貸業（電子計算機を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,70,704,0000": {
                        "name": "自動車賃貸業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,70,705,0000": {
                        "name": "スポーツ・娯楽用品賃貸業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "K,70,709,0000": {
                        "name": "貸衣しょう業（別掲を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "L,00,000,0000": {
        "name": "学術研究，専門・技術サービス業",
        "hitcount": undefined,
        "childDataDict": {
            "L,71,000,0000": {
                "name": "学術・開発研究機関",
                "hitcount": undefined,
                "childDataDict": {
                    "L,71,710,0000": {
                        "name": "管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,71,711,0000": {
                        "name": "工学研究所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,71,712,0000": {
                        "name": "人文・社会科学研究所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "L,72,000,0000": {
                "name": "専門サービス業（他に分類されないもの）",
                "hitcount": undefined,
                "childDataDict": {
                    "L,72,720,0000": {
                        "name": "管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,721,0000": {
                        "name": "法律事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,722,0000": {
                        "name": "土地家屋調査士事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,723,0000": {
                        "name": "行政書士事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,724,0000": {
                        "name": "税理士事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,725,0000": {
                        "name": "社会保険労務士事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,726,0000": {
                        "name": "デザイン業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,727,0000": {
                        "name": "著述・芸術家業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,728,0000": {
                        "name": "純粋持株会社",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,72,729,0000": {
                        "name": "興信所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "L,73,000,0000": {
                "name": "広告業",
                "hitcount": undefined,
                "childDataDict": {
                    "L,73,730,0000": {
                        "name": "管理，補助的経済活動を行う事業所（73広告業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,73,731,0000": {
                        "name": "広告業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "L,74,000,0000": {
                "name": "技術サービス業（他に分類されないもの）",
                "hitcount": undefined,
                "childDataDict": {
                    "L,74,740,0000": {
                        "name": "管理，補助的経済活動を行う事業所（74技術サービス業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,741,0000": {
                        "name": "獣医業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,742,0000": {
                        "name": "測量業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,743,0000": {
                        "name": "機械設計業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,744,0000": {
                        "name": "商品検査業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,745,0000": {
                        "name": "環境計量証明業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,746,0000": {
                        "name": "写真業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "L,74,749,0000": {
                        "name": "その他の技術サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "M,00,000,0000": {
        "name": "宿泊業，飲食サービス業",
        "hitcount": undefined,
        "childDataDict": {
            "M,75,000,0000": {
                "name": "宿泊業",
                "hitcount": undefined,
                "childDataDict": {
                    "M,75,750,0000": {
                        "name": "管理，補助的経済活動を行う事業所（75宿泊業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,75,751,0000": {
                        "name": "旅館，ホテル",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,75,752,0000": {
                        "name": "簡易宿所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,75,753,0000": {
                        "name": "下宿業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,75,759,0000": {
                        "name": "会社・団体の宿泊所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "M,76,000,0000": {
                "name": "飲食店",
                "hitcount": undefined,
                "childDataDict": {
                    "M,76,760,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,761,0000": {
                        "name": "食堂，レストラン（専門料理店を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,762,0000": {
                        "name": "日本料理店",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,763,0000": {
                        "name": "そば・うどん店",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,764,0000": {
                        "name": "すし店",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,765,0000": {
                        "name": "酒場，ビヤホール",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,766,0000": {
                        "name": "バー，キャバレー，ナイトクラブ",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,767,0000": {
                        "name": "喫茶店",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,76,769,0000": {
                        "name": "その他の飲食店",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "M,77,000,0000": {
                "name": "持ち帰り・配達飲食サービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "M,77,770,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,77,771,0000": {
                        "name": "持ち帰り飲食サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "M,77,772,0000": {
                        "name": "配達飲食サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "N,00,000,0000": {
        "name": "生活関連サービス業，娯楽業",
        "hitcount": undefined,
        "childDataDict": {
            "N,78,000,0000": {
                "name": "洗濯・理容・美容・浴場業",
                "hitcount": undefined,
                "childDataDict": {
                    "N,78,780,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,78,781,0000": {
                        "name": "洗濯物取次業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,78,782,0000": {
                        "name": "理容業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,78,783,0000": {
                        "name": "美容業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,78,784,0000": {
                        "name": "一般公衆浴場業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,78,785,0000": {
                        "name": "その他の公衆浴場業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,78,789,0000": {
                        "name": "他に分類されない洗濯・理容・美容・浴場業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "N,79,000,0000": {
                "name": "その他の生活関連サービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "N,79,790,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,791,0000": {
                        "name": "旅行業(旅行業者代理業を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,792,0000": {
                        "name": "家事サービス業（住込みのもの）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,793,0000": {
                        "name": "衣服裁縫修理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,794,0000": {
                        "name": "物品預り業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,795,0000": {
                        "name": "火葬・墓地管理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,796,0000": {
                        "name": "結婚式場業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,79,799,0000": {
                        "name": "他に分類されない生活関連サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "N,80,000,0000": {
                "name": "娯楽業",
                "hitcount": undefined,
                "childDataDict": {
                    "N,80,800,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,801,0000": {
                        "name": "映画館",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,802,0000": {
                        "name": "興行場（別掲を除く），興行団",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,803,0000": {
                        "name": "競輪・競馬等の競走場，競技団",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,804,0000": {
                        "name": "ゴルフ練習場",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,805,0000": {
                        "name": "公園",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,806,0000": {
                        "name": "ビリヤード場",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "N,80,809,0000": {
                        "name": "芸ぎ業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "O,00,000,0000": {
        "name": "教育，学習支援業",
        "hitcount": undefined,
        "childDataDict": {
            "O,81,000,0000": {
                "name": "学校教育",
                "hitcount": undefined,
                "childDataDict": {
                    "O,81,810,0000": {
                        "name": "管理，補助的経済活動を行う事業所（81学校教育）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,811,0000": {
                        "name": "幼稚園",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,812,0000": {
                        "name": "小学校",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,813,0000": {
                        "name": "中学校",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,814,0000": {
                        "name": "高等学校，中等教育学校",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,815,0000": {
                        "name": "特別支援学校",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,816,0000": {
                        "name": "高等教育機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,817,0000": {
                        "name": "専修学校，各種学校",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,818,0000": {
                        "name": "学校教育支援機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,81,819,0000": {
                        "name": "幼保連携型認定こども園",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "O,82,000,0000": {
                "name": "その他の教育，学習支援業",
                "hitcount": undefined,
                "childDataDict": {
                    "O,82,820,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,82,821,0000": {
                        "name": "青少年教育施設",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,82,822,0000": {
                        "name": "職員教育施設・支援業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,82,823,0000": {
                        "name": "学習塾",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,82,824,0000": {
                        "name": "教養・技能教授業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "O,82,829,0000": {
                        "name": "他に分類されない教育，学習支援業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "P,00,000,0000": {
        "name": "医療，福祉",
        "hitcount": undefined,
        "childDataDict": {
            "P,83,000,0000": {
                "name": "医療業",
                "hitcount": undefined,
                "childDataDict": {
                    "P,83,830,0000": {
                        "name": "管理，補助的経済活動を行う事業所（83医療業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,83,831,0000": {
                        "name": "精神科病院",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,83,832,0000": {
                        "name": "一般診療所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,83,833,0000": {
                        "name": "歯科診療所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,83,834,0000": {
                        "name": "看護業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,83,835,0000": {
                        "name": "療術業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,83,836,0000": {
                        "name": "その他の医療に附帯するサービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "P,84,000,0000": {
                "name": "保健衛生",
                "hitcount": undefined,
                "childDataDict": {
                    "P,84,840,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,84,841,0000": {
                        "name": "保健所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,84,842,0000": {
                        "name": "精神保健相談施設",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,84,849,0000": {
                        "name": "消毒業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "P,85,000,0000": {
                "name": "社会保険・社会福祉・介護事業",
                "hitcount": undefined,
                "childDataDict": {
                    "P,85,850,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,85,851,0000": {
                        "name": "社会保険事業団体",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,85,852,0000": {
                        "name": "福祉事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,85,853,0000": {
                        "name": "その他の児童福祉事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,85,854,0000": {
                        "name": "その他の老人福祉・介護事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,85,855,0000": {
                        "name": "居住支援事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "P,85,859,0000": {
                        "name": "更生保護事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "Q,00,000,0000": {
        "name": "複合サービス事業",
        "hitcount": undefined,
        "childDataDict": {
            "Q,86,000,0000": {
                "name": "郵便局",
                "hitcount": undefined,
                "childDataDict": {
                    "Q,86,860,0000": {
                        "name": "管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "Q,86,861,0000": {
                        "name": "郵便局",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "Q,86,862,0000": {
                        "name": "簡易郵便局",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "Q,87,000,0000": {
                "name": "協同組合（他に分類されないもの）",
                "hitcount": undefined,
                "childDataDict": {
                    "Q,87,870,0000": {
                        "name": "管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "Q,87,871,0000": {
                        "name": "農業協同組合（他に分類されないもの）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "Q,87,872,0000": {
                        "name": "事業協同組合（他に分類されないもの）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "S,00,000,0000": {
        "name": "公務（他に分類されるものを除く）",
        "hitcount": undefined,
        "childDataDict": {
            "S,97,000,0000": {
                "name": "国家公務",
                "hitcount": undefined,
                "childDataDict": {
                    "S,97,971,0000": {
                        "name": "立法機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "S,97,972,0000": {
                        "name": "司法機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "S,97,973,0000": {
                        "name": "行政機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "S,98,000,0000": {
                "name": "地方公務",
                "hitcount": undefined,
                "childDataDict": {
                    "S,98,981,0000": {
                        "name": "都道府県機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "S,98,982,0000": {
                        "name": "市町村機関",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "T,00,000,0000": {
        "name": "分類不能の産業",
        "hitcount": undefined,
        "childDataDict": {
            "T,99,000,0000": {
                "name": "分類不能の産業",
                "hitcount": undefined,
                "childDataDict": {
                    "T,99,999,0000": {
                        "name": "分類不能の産業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "G,00,000,0000": {
        "name": "情報通信業",
        "hitcount": undefined,
        "childDataDict": {
            "G,38,000,0000": {
                "name": "放送業",
                "hitcount": undefined,
                "childDataDict": {
                    "G,38,380,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,38,381,0000": {
                        "name": "公共放送業（有線放送業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,38,382,0000": {
                        "name": "テレビジョン放送業（衛星放送業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,38,383,0000": {
                        "name": "有線ラジオ放送業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "G,41,000,0000": {
                "name": "映像・音声・文字情報制作業",
                "hitcount": undefined,
                "childDataDict": {
                    "G,41,410,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,41,411,0000": {
                        "name": "アニメーション制作業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,41,412,0000": {
                        "name": "レコード制作業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,41,413,0000": {
                        "name": "新聞業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,41,414,0000": {
                        "name": "出版業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,41,415,0000": {
                        "name": "広告制作業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,41,416,0000": {
                        "name": "映像・音声・文字情報制作に附帯するサービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "G,37,000,0000": {
                "name": "通信業",
                "hitcount": undefined,
                "childDataDict": {
                    "G,37,372,0000": {
                        "name": "移動電気通信業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,37,371,0000": {
                        "name": "地域電気通信業（有線放送電話業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,37,373,0000": {
                        "name": "電気通信に附帯するサービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,37,370,0000": {
                        "name": "管理，補助的経済活動を行う事業所（37通信業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "G,39,000,0000": {
                "name": "情報サービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "G,39,390,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,39,391,0000": {
                        "name": "受託開発ソフトウェア業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,39,392,0000": {
                        "name": "情報処理サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "G,40,000,0000": {
                "name": "インターネット附随サービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "G,40,400,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "G,40,401,0000": {
                        "name": "インターネット利用サポート業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "D,00,000,0000": {
        "name": "建設業",
        "hitcount": undefined,
        "childDataDict": {
            "D,06,000,0000": {
                "name": "総合工事業",
                "hitcount": undefined,
                "childDataDict": {
                    "D,06,060,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,06,061,0000": {
                        "name": "一般土木建築工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,06,062,0000": {
                        "name": "土木工事業(別掲を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,06,063,0000": {
                        "name": "舗装工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,06,064,0000": {
                        "name": "建築工事業(木造建築工事業を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,06,065,0000": {
                        "name": "木造建築工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,06,066,0000": {
                        "name": "建築リフォーム工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "D,07,000,0000": {
                "name": "職別工事業(設備工事業を除く)",
                "hitcount": undefined,
                "childDataDict": {
                    "D,07,070,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,071,0000": {
                        "name": "大工工事業(型枠大工工事業を除く)",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,072,0000": {
                        "name": "土工・コンクリート工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,073,0000": {
                        "name": "鉄骨工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,074,0000": {
                        "name": "タイル工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,075,0000": {
                        "name": "左官工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,076,0000": {
                        "name": "板金工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,077,0000": {
                        "name": "道路標示・区画線工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,078,0000": {
                        "name": "床工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,07,079,0000": {
                        "name": "ガラス工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "D,08,000,0000": {
                "name": "設備工事業",
                "hitcount": undefined,
                "childDataDict": {
                    "D,08,080,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,08,081,0000": {
                        "name": "電気工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,08,082,0000": {
                        "name": "電気通信工事業（有線テレビジョン放送設備設置工事業を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,08,083,0000": {
                        "name": "冷暖房設備工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,08,089,0000": {
                        "name": "道路標識設置工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "D,08,084,0000": {
                        "name": "昇降設備工事業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    },
    "R,00,000,0000": {
        "name": "サービス業（他に分類されないもの）",
        "hitcount": undefined,
        "childDataDict": {
            "R,88,000,0000": {
                "name": "廃棄物処理業",
                "hitcount": undefined,
                "childDataDict": {
                    "R,88,880,0000": {
                        "name": "その他の管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,88,881,0000": {
                        "name": "ごみ処分業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,88,882,0000": {
                        "name": "産業廃棄物処分業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,88,889,0000": {
                        "name": "他に分類されない廃棄物処理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,89,000,0000": {
                "name": "自動車整備業",
                "hitcount": undefined,
                "childDataDict": {
                    "R,89,890,0000": {
                        "name": "管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,89,891,0000": {
                        "name": "自動車整備業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,90,000,0000": {
                "name": "機械等修理業（別掲を除く）",
                "hitcount": undefined,
                "childDataDict": {
                    "R,90,900,0000": {
                        "name": "管理，補助的経済活動を行う事業所（90機械等修理業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,90,901,0000": {
                        "name": "機械修理業（電気機械器具を除く）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,90,902,0000": {
                        "name": "電気機械器具修理業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,90,903,0000": {
                        "name": "表具業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,90,909,0000": {
                        "name": "かじ業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,91,000,0000": {
                "name": "職業紹介・労働者派遣業",
                "hitcount": undefined,
                "childDataDict": {
                    "R,91,910,0000": {
                        "name": "管理，補助的経済活動を行う事業所（91職業紹介・労働者派遣業）",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,91,911,0000": {
                        "name": "職業紹介業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,91,912,0000": {
                        "name": "労働者派遣業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,92,000,0000": {
                "name": "その他の事業サービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "R,92,920,0000": {
                        "name": "主として管理事務を行う本社等",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,92,921,0000": {
                        "name": "複写業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,92,922,0000": {
                        "name": "その他の建物サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,92,923,0000": {
                        "name": "警備業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,92,929,0000": {
                        "name": "他に分類されないその他の事業サービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,93,000,0000": {
                "name": "政治・経済・文化団体",
                "hitcount": undefined,
                "childDataDict": {
                    "R,93,931,0000": {
                        "name": "経済団体",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,93,932,0000": {
                        "name": "労働団体",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,93,933,0000": {
                        "name": "文化団体",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,93,934,0000": {
                        "name": "政治団体",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,93,939,0000": {
                        "name": "他に分類されない非営利的団体",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,94,000,0000": {
                "name": "宗教",
                "hitcount": undefined,
                "childDataDict": {
                    "R,94,941,0000": {
                        "name": "教派事務所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,94,942,0000": {
                        "name": "仏教系宗教",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,94,943,0000": {
                        "name": "キリスト教系宗教",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,94,949,0000": {
                        "name": "その他の宗教の教会",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,96,000,0000": {
                "name": "外国公務",
                "hitcount": undefined,
                "childDataDict": {
                    "R,96,961,0000": {
                        "name": "外国公館",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,96,969,0000": {
                        "name": "その他の外国公務",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            },
            "R,95,000,0000": {
                "name": "その他のサービス業",
                "hitcount": undefined,
                "childDataDict": {
                    "R,95,950,0000": {
                        "name": "管理，補助的経済活動を行う事業所",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,95,951,0000": {
                        "name": "集会場",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,95,952,0000": {
                        "name": "と畜場",
                        "hitcount": undefined,
                        "childDataDict": {}
                    },
                    "R,95,959,0000": {
                        "name": "他に分類されないサービス業",
                        "hitcount": undefined,
                        "childDataDict": {}
                    }
                }
            }
        }
    }
}